import Head from 'next/head'
import React, { FC } from 'react'
import { useLicenseScope } from '@/contexts/LicenseScopeContext'
import { getDomainBranding } from '@saasalerts/ui'

export const AppHead: FC = () => {
  const licenseScope = useLicenseScope()
  const branding = getDomainBranding(licenseScope)!
  const faviconFolder = `/favicons/${branding.product.toLowerCase()}`

  return (
    <Head>
      <title>{branding.name}</title>
      <link
        rel="icon"
        type="image/png"
        href={`${faviconFolder}/favicon-96x96.png`}
        sizes="96x96"
      />
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${faviconFolder}/favicon.svg`}
      />
      <link rel="shortcut icon" href={`${faviconFolder}/favicon.ico`} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${faviconFolder}/apple-touch-icon.png`}
      />
      <link rel="manifest" href={`${faviconFolder}/site.webmanifest`} />
    </Head>
  )
}
